import { DEFAULT_FEED_KEY, FEED_AUTHORS, FEED_MAP, getFeedCharacterLimit } from '../config/feed-details';

export const buildPostPath = (author, permlink) => {
  if (!author || !permlink) return '#';
  return `/post/${author}/${permlink}`;
};

export const buildFlexDetailPath = (author, permlink) => {
  if (!author || !permlink) return '#';
  // Flex detail view currently relies on the legacy route shape.
  return `/post/flexdetail/${author}/${permlink}`;
};

export const getRootAuthor = (content) => {
  if (!content) return null;
  return content.root_author || content.rootAuthor || content.parent_author || content.parentAuthor || null;
};

export const getRootFeedKey = (content) => {
  const rootAuthor = getRootAuthor(content);
  if (!rootAuthor || !FEED_AUTHORS.includes(rootAuthor)) return null;
  return FEED_MAP[rootAuthor] || DEFAULT_FEED_KEY;
};

export const getReplyCharacterLimit = (content) => {
  const feedKey = getRootFeedKey(content);
  return feedKey ? getFeedCharacterLimit(feedKey) : null;
};

export const buildContentPath = (author, permlink, content) => {
  if (!author || !permlink) return '#';
  const rootAuthor = getRootAuthor(content);
  return rootAuthor && FEED_AUTHORS.includes(rootAuthor)
    ? buildFlexDetailPath(author, permlink)
    : buildPostPath(author, permlink);
};
